import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import WhatIsTrainingSectionStyle from './style';

import Image from '@components/atoms/image';
import config from 'src/config';

const WhatIsTrainingSection = () => {
  const { t } = useTranslation('common');

  return (
    <WhatIsTrainingSectionStyle>
      <Grid container item xs={12} xl={12} spacing={2} sx={{ my: { lg: 10, sm: 5 } }}>
        <Grid item xs={12} sm={12} md={12} lg={5} xl={5} className="col1">
          <Image
            alt={t('cpd.common.training.for.request.license')}
            src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.png`}
            srcSet={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.png, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD@2x.png 2x`}
            srcSetWebp={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.webp, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD@2x.webp 2x`}
            errorImage={`${config.IMAGE_CDN_HOST}/assets/thumbnail-course-card.jpg`}
          />
        </Grid>
        <Grid item xs={0} sm={0} md={0} lg={1} xl={1} />
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className="col2">
          <Box>
            <Typography color="#164843" variant="h1" className="topic">
              SkillLaneCPD
            </Typography>
            <Typography color="#164843" variant="h1" className="topic">
              {t('cpd.common.what.is.training')}
            </Typography>
            <Typography color="rgba(0, 0, 0, 0.6)" variant="body2_deprecated" fontFamily="lanna" className="description">
              {t('cpd.common.what.is.training.description')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={0} xl={0} className="col3">
          <Image
            alt={t('cpd.common.training.for.request.license')}
            src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.png`}
            srcSet={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.png, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD@2x.png 2x`}
            srcSetWebp={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD.webp, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/WhatSkillLaneCPD@2x.webp 2x`}
            errorImage={`${config.IMAGE_CDN_HOST}/assets/thumbnail-course-card.jpg`}
          />
        </Grid>
      </Grid>
    </WhatIsTrainingSectionStyle>
  );
};

export default WhatIsTrainingSection;
